<template>
  <v-container fluid class="pa-0">
    <v-row dense class="mb-2">
      <v-col cols="12" md="3">
        <datePicker
          v-model="filtros.desde"
          format="YYYY-MM-DD"
          label="Desde"
          clearable
          maxToday
        />
      </v-col>
      <v-col cols="12" md="3">
        <datePicker
          v-model="filtros.hasta"
          format="YYYY-MM-DD"
          label="Hasta"
          clearable
          maxToday
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="filtros.tipoBono"
          :items="tiposBonoItems"
          item-text="text"
          item-value="value"
          label="Tipo de bono"
          outlined
          dense
          hide-details
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          v-model="filtros.search"
          label="Buscar"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          hide-details
          clearable
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filtros.idArea"
          :items="areasItems"
          item-text="text"
          item-value="value"
          label="Area"
          outlined
          dense
          clearable
          hide-details
          :loading="loadingCatalogos"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filtros.idPuesto"
          :items="puestosItems"
          item-text="text"
          item-value="value"
          label="Puesto"
          outlined
          dense
          clearable
          hide-details
          :loading="loadingCatalogos"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
          v-model="filtros.idPersona"
          :items="personasItems"
          item-text="text"
          item-value="value"
          label="Persona"
          outlined
          dense
          clearable
          hide-details
          :loading="loadingCatalogos"
        />
      </v-col>
      <v-col cols="12" class="d-flex justify-end">
        <v-btn outlined color="primary" class="mr-2" @click="limpiarFiltros">Limpiar filtros</v-btn>
        <v-btn outlined color="primary" class="mr-2" :loading="loading" @click="consultar">Consultar</v-btn>
        <v-btn color="primary" @click="descargarCsv">Descargar CSV</v-btn>
      </v-col>
    </v-row>

    <v-row dense class="mb-2">
      <v-col cols="12" md="3">
        <v-chip outlined color="indigo">Registros: <b class="ml-1">{{ rows.length }}</b></v-chip>
      </v-col>
      <v-col cols="12" md="3">
        <v-chip outlined color="green">Pagado: <b class="ml-1">{{ fmtCurrency(totalPagado) }}</b></v-chip>
      </v-col>
      <v-col cols="12" md="3">
        <v-chip outlined color="amber">Pendiente: <b class="ml-1">{{ fmtCurrency(totalPendiente) }}</b></v-chip>
      </v-col>
      <v-col cols="12" md="3">
        <v-chip outlined color="blue-grey">No aplica: <b class="ml-1">{{ totalNoAplica }}</b></v-chip>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="rows"
      :loading="loading"
      :items-per-page="20"
      class="elevation-1"
    >
      <template v-slot:item.tipoBono="{ item }">
        <v-chip x-small outlined :color="item.tipoBono === 'KPI' ? 'indigo' : 'blue-grey'">
          {{ item.tipoBono }}
        </v-chip>
      </template>
      <template v-slot:item.total="{ item }">{{ fmtCurrency(item.total) }}</template>
      <template v-slot:item.montoPagado="{ item }">{{ fmtCurrency(item.montoPagado) }}</template>
      <template v-slot:item.montoPendiente="{ item }">{{ fmtCurrency(item.montoPendiente) }}</template>
      <template v-slot:item.porcentajeActual="{ item }">
        {{ item.porcentajeActual === null ? "N/A" : fmtPct(item.porcentajeActual) }}
      </template>
      <template v-slot:item.proximoPago="{ item }">{{ fmtDate(item.proximoPago) }}</template>
    </v-data-table>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  props: {
    active: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      loadingCatalogos: false,
      bootstrapped: false,
      rows: [],
      areasItems: [],
      puestosItems: [],
      personasItems: [],
      filtros: this.getDefaultFiltros(),
      tiposBonoItems: [
        { text: "Todos", value: "TODOS" },
        { text: "General", value: "GENERAL" },
        { text: "KPI", value: "KPI" }
      ],
      headers: [
        { text: "Persona", value: "persona", sortable: true },
        { text: "Area", value: "area", sortable: true },
        { text: "Puesto", value: "puesto", sortable: true },
        { text: "Tipo bono", value: "tipoBono", sortable: true },
        { text: "Codigo", value: "codigo", sortable: true },
        { text: "Bono", value: "bono", sortable: true },
        { text: "Total", value: "total", sortable: true },
        { text: "Pagado", value: "montoPagado", sortable: true },
        { text: "Pendiente", value: "montoPendiente", sortable: true },
        { text: "No aplica", value: "noAplica", sortable: true },
        { text: "Alcanzado", value: "porcentajeActual", sortable: true },
        { text: "Proximo pago", value: "proximoPago", sortable: true }
      ]
    };
  },
  computed: {
    totalPagado() {
      return this.rows.reduce((acc, x) => acc + Number(x.montoPagado || 0), 0);
    },
    totalPendiente() {
      return this.rows.reduce((acc, x) => acc + Number(x.montoPendiente || 0), 0);
    },
    totalNoAplica() {
      return this.rows.reduce((acc, x) => acc + Number(x.noAplica || 0), 0);
    }
  },
  watch: {
    active(v) {
      if (v) this.ensureData();
    }
  },
  mounted() {
    if (this.active) this.ensureData();
  },
  methods: {
    getDefaultFiltros() {
      return {
        tipoBono: "TODOS",
        idArea: null,
        idPuesto: null,
        idPersona: null,
        search: "",
        desde: null,
        hasta: null
      };
    },
    async ensureData() {
      if (this.bootstrapped) return;
      await this.initialize();
      this.bootstrapped = true;
    },
    /*
      initialize:
      - Carga catálogos para filtros (área, puesto, persona)
      - Carga datos iniciales del reporte usando /Reportes/BonosGeneral
    */
    async initialize() {
      this.loadingCatalogos = true;
      try {
        const [areasRes, puestosRes, personasRes] = await Promise.all([
          axios.get("/Areas"),
          axios.get("/Puestos"),
          axios.get("/Personas")
        ]);

        const areas = Array.isArray(areasRes.data) ? areasRes.data : [];
        const puestos = Array.isArray(puestosRes.data) ? puestosRes.data : [];
        const personas = Array.isArray(personasRes.data) ? personasRes.data : [];

        this.areasItems = areas.map(a => ({ text: a.nombre || String(a.idArea), value: Number(a.idArea) }));
        this.puestosItems = puestos.map(p => ({ text: p.nombre || String(p.idPuesto), value: Number(p.idPuesto) }));
        this.personasItems = personas.map(p => ({
          text: [p.nombre, p.paterno, p.materno].filter(Boolean).join(" "),
          value: Number(p.idPersona)
        }));
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingCatalogos = false;
      }

      await this.consultar();
    },
    /*
      consultar:
      - Consume el endpoint oficial backend: GET /Reportes/BonosGeneral
      - Envía filtros como query params opcionales.
    */
    async consultar() {
      this.loading = true;
      try {
        const params = this.buildQueryParams();
        const { data } = await axios.get("/Reportes/BonosGeneral", { params });
        const rows = Array.isArray(data) ? data : [];
        this.rows = rows.map(this.normalizeRow);
      } catch (e) {
        console.log(e);
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },
    buildQueryParams() {
      const p = {};
      p.tipoBono = this.filtros.tipoBono || "TODOS";
      if (this.filtros.idArea !== null && this.filtros.idArea !== undefined) p.idArea = Number(this.filtros.idArea);
      if (this.filtros.idPuesto !== null && this.filtros.idPuesto !== undefined) p.idPuesto = Number(this.filtros.idPuesto);
      if (this.filtros.idPersona !== null && this.filtros.idPersona !== undefined) p.idPersona = Number(this.filtros.idPersona);
      if (String(this.filtros.search || "").trim().length > 0) p.search = String(this.filtros.search).trim();
      if (this.filtros.desde) p.desde = this.filtros.desde;
      if (this.filtros.hasta) p.hasta = this.filtros.hasta;
      return p;
    },
    normalizeRow(r) {
      return {
        idPersona: r.idPersona,
        persona: r.persona || "N/A",
        area: r.area || "N/A",
        puesto: r.puesto || "N/A",
        tipoBono: String(r.tipoBono || "GENERAL").toUpperCase(),
        idBono: r.idBono,
        codigo: r.codigo || "N/A",
        bono: r.bono || "N/A",
        total: Number(r.total || 0),
        montoPagado: Number(r.montoPagado || 0),
        montoPendiente: Number(r.montoPendiente || 0),
        noAplica: Number(r.noAplica || 0),
        porcentajeActual: (r.porcentajeActual === null || r.porcentajeActual === undefined) ? null : Number(r.porcentajeActual),
        proximoPago: r.proximoPago || null,
        idArea: (r.idArea === null || r.idArea === undefined) ? null : Number(r.idArea),
        idPuesto: (r.idPuesto === null || r.idPuesto === undefined) ? null : Number(r.idPuesto)
      };
    },
    limpiarFiltros() {
      this.filtros = this.getDefaultFiltros();
      this.consultar();
    },
    fmtCurrency(value) {
      const n = Number(value || 0);
      return n.toLocaleString("es-MX", { style: "currency", currency: "MXN" });
    },
    fmtPct(value) {
      const n = Number(value);
      if (!Number.isFinite(n)) return "0%";
      return n.toLocaleString("es-MX", { minimumFractionDigits: 1, maximumFractionDigits: 2 }) + "%";
    },
    fmtDate(value) {
      if (!value) return "N/A";
      const d = new Date(value);
      if (isNaN(d.getTime())) return String(value);
      return d.toLocaleDateString("es-MX");
    },
    descargarCsv() {
      const headers = [
        "Persona", "Area", "Puesto", "TipoBono", "Codigo", "Bono",
        "Total", "Pagado", "Pendiente", "NoAplica", "PorcentajeActual", "ProximoPago"
      ];
      const lines = [headers.join(",")];
      this.rows.forEach((r) => {
        const cols = [
          r.persona, r.area, r.puesto, r.tipoBono, r.codigo, r.bono,
          r.total, r.montoPagado, r.montoPendiente, r.noAplica,
          r.porcentajeActual === null ? "" : r.porcentajeActual,
          this.fmtDate(r.proximoPago)
        ].map((x) => `"${String(x === null || x === undefined ? "" : x).replace(/"/g, "\"\"")}"`);
        lines.push(cols.join(","));
      });

      const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const href = URL.createObjectURL(blob);
      link.href = href;
      link.download = "reporte-bonos-general.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(href);
    }
  }
};
</script>
